import { ref, watch } from 'vue'

export default function useInit(watchValue: any) {
  let init = false
  const loading = ref(true)
  watch(
    () => watchValue,
    (val) => {
      if (init === false) {
        init = true
      } else {
        loading.value = false
      }
    },
    {
      deep: true,
      immediate: true,
    }
  )
  return {
    loading,
  }
}
